import type {
	Components,
} from '@mui/material'

export const materialUIListTheme: {
	components: Components
} = {
	components: {
		MuiList: {
			styleOverrides: {
			},
		},

		MuiListItemButton: {
			styleOverrides: {
			},
		},
	},
}
